module.exports = __webpack_public_path__ + "static/media/billing.c735b3b5.svg";